export const checkAnyIntersect = (first: string[], second: string[]) =>
  first.some((firstItem) => second.find((secondItem) => firstItem === secondItem))
